/**
 * THIS FILE IS AUTO-GENERATED. DO NOT EDIT MANUALLY.
 * Generated from ../../api/openapi.json
 * Generated by generate-diSlice-tables.ts
 * To regenerate, run the following command in the frontend folder:
 *    pnpm run generate:integration
 * Contact the Core Team if any issues arise.
 */

import api, { Schemas } from '~/clients/api-client'
import { SomeEntity } from '~/clients/api-guards'

import { createEntityState, EntityTable } from './diSlice-utils'

export const entityKeys = [
    'ageGroups',
    'backfillQueues',
    'blockSchedules',
    'checklistItemDefinitions',
    'comments',
    'commentsMessageReactions',
    'commentsMessages',
    'commentsThreadReactions',
    'commentsThreads',
    'departmentLocationAssignments',
    'departmentPractitionerAssignments',
    'departments',
    'hospitalSurgeryTypeGroupAssociations',
    'hospitalSurgeryTypes',
    'inboxEntries',
    'locationPostOpAssociations',
    'locationProfiles',
    'locationProfileSurgeryTypeGroups',
    'locations',
    'locationScheduleActivityLogs',
    'locationSchedules',
    'locationScheduleSpecialities',
    'locationScheduleSpecialityActivityLogs',
    'locationServiceOverrides',
    'mailingList',
    'planningDomains',
    'planningNoteHistoryRecords',
    'planningNoteMigrations',
    'planningPeriods',
    'postOpCapacityOverrides',
    'postOpCapacityPeriods',
    'postOps',
    'practitionerProfiles',
    'practitionerProfileSurgeryTypeGroups',
    'practitioners',
    'practitionerScheduleActivityLogs',
    'practitionerScheduleLocationActivityLogs',
    'practitionerScheduleLocations',
    'practitionerSchedules',
    'practitionerScheduleStatusActivityLogs',
    'practitionerScheduleStatuses',
    'practitionerServicePeriods',
    'practitionerStatusDefinitions',
    'prioritizedPatientGroups',
    'recurringAssignments',
    'sections',
    'specialities',
    'staffingPlanExecutions',
    'staffingSurgeryGroups',
    'staffingSurgeryGroupSurgeryTypeGroups',
    'statusDefinitionDepartmentAssignments',
    'surgeryFolderMetadata',
    'surgeryMetadataSuggestions',
    'surgeryTypeGroupAgeRestrictions',
    'surgeryTypeGroupHierarchies',
    'surgeryTypeGroups',
    'surgeryTypeGroupSpecialities',
    'tacticalPlanSnapshots',
] as const

export type DiEntityKeys = typeof entityKeys
export type DiEntityKey = DiEntityKeys[number]

export const entityStates = {
    ageGroups: createEntityState<Schemas['AgeGroupOut']>(),
    backfillQueues: createEntityState<Schemas['BackfillQueueOut']>(),
    blockSchedules: createEntityState<Schemas['BlockScheduleOut']>(),
    checklistItemDefinitions: createEntityState<Schemas['ChecklistItemDefinitionOut']>(),
    comments: createEntityState<Schemas['CommentOut']>(),
    commentsMessageReactions: createEntityState<Schemas['CommentsMessageReactionOut']>(),
    commentsMessages: createEntityState<Schemas['CommentsMessageOut']>(),
    commentsThreadReactions: createEntityState<Schemas['CommentsThreadReactionOut']>(),
    commentsThreads: createEntityState<Schemas['CommentsThreadOut']>(),
    departmentLocationAssignments: createEntityState<Schemas['DepartmentLocationAssignmentOut']>(),
    departmentPractitionerAssignments: createEntityState<Schemas['DepartmentPractitionerAssignmentOut']>(),
    departments: createEntityState<Schemas['DepartmentOut']>(),
    hospitalSurgeryTypeGroupAssociations: createEntityState<Schemas['HospitalSurgeryTypeGroupAssociationOut']>(),
    hospitalSurgeryTypes: createEntityState<Schemas['HospitalSurgeryTypeOut']>(),
    inboxEntries: createEntityState<Schemas['InboxEntryOut']>(),
    locationPostOpAssociations: createEntityState<Schemas['LocationPostOpAssociationOut']>(),
    locationProfiles: createEntityState<Schemas['LocationProfileOut']>(),
    locationProfileSurgeryTypeGroups: createEntityState<Schemas['LocationProfileSurgeryTypeGroupOut']>(),
    locations: createEntityState<Schemas['LocationOut']>(),
    locationScheduleActivityLogs: createEntityState<Schemas['LocationScheduleActivityLogOut']>(),
    locationSchedules: createEntityState<Schemas['LocationScheduleOut']>(),
    locationScheduleSpecialities: createEntityState<Schemas['LocationScheduleSpecialityOut']>(),
    locationScheduleSpecialityActivityLogs: createEntityState<Schemas['LocationScheduleSpecialityActivityLogOut']>(),
    locationServiceOverrides: createEntityState<Schemas['LocationServiceOverrideOut']>(),
    mailingList: createEntityState<Schemas['MailingListOut']>(),
    planningDomains: createEntityState<Schemas['PlanningDomainOut']>(),
    planningNoteHistoryRecords: createEntityState<Schemas['PlanningNoteHistoryRecordOut']>(),
    planningNoteMigrations: createEntityState<Schemas['PlanningNoteMigrationRecordOut']>(),
    planningPeriods: createEntityState<Schemas['PlanningPeriodOut']>(),
    postOpCapacityOverrides: createEntityState<Schemas['PostOpCapacityOverrideOut']>(),
    postOpCapacityPeriods: createEntityState<Schemas['PostOpCapacityPeriodOut']>(),
    postOps: createEntityState<Schemas['PostOpOut']>(),
    practitionerProfiles: createEntityState<Schemas['PractitionerProfileOut']>(),
    practitionerProfileSurgeryTypeGroups: createEntityState<Schemas['PractitionerProfileSurgeryTypeGroupOut']>(),
    practitioners: createEntityState<Schemas['PractitionerOut']>(),
    practitionerScheduleActivityLogs: createEntityState<Schemas['PractitionerScheduleActivityLogOut']>(),
    practitionerScheduleLocationActivityLogs: createEntityState<Schemas['PractitionerScheduleLocationActivityLogOut']>(),
    practitionerScheduleLocations: createEntityState<Schemas['PractitionerScheduleLocationOut']>(),
    practitionerSchedules: createEntityState<Schemas['PractitionerScheduleOut']>(),
    practitionerScheduleStatusActivityLogs: createEntityState<Schemas['PractitionerScheduleStatusActivityLogOut']>(),
    practitionerScheduleStatuses: createEntityState<Schemas['PractitionerScheduleStatusOut']>(),
    practitionerServicePeriods: createEntityState<Schemas['PractitionerServicePeriodOut']>(),
    practitionerStatusDefinitions: createEntityState<Schemas['PractitionerStatusDefinitionOut']>(),
    prioritizedPatientGroups: createEntityState<Schemas['PrioritizedPatientGroupOut']>(),
    recurringAssignments: createEntityState<Schemas['RecurringAssignmentOut']>(),
    sections: createEntityState<Schemas['SectionOut']>(),
    specialities: createEntityState<Schemas['SpecialityOut']>(),
    staffingPlanExecutions: createEntityState<Schemas['StaffingPlanExecutionOut']>(),
    staffingSurgeryGroups: createEntityState<Schemas['StaffingSurgeryGroupOut']>(),
    staffingSurgeryGroupSurgeryTypeGroups: createEntityState<Schemas['StaffingSurgeryGroupSurgeryTypeGroupOut']>(),
    statusDefinitionDepartmentAssignments: createEntityState<Schemas['StatusDefinitionDepartmentAssignmentOut']>(),
    surgeryFolderMetadata: createEntityState<Schemas['SurgeryFolderMetadatumOut']>(),
    surgeryMetadataSuggestions: createEntityState<Schemas['SurgeryMetadataSuggestionOut']>(),
    surgeryTypeGroupAgeRestrictions: createEntityState<Schemas['SurgeryTypeGroupAgeRestrictionOut']>(),
    surgeryTypeGroupHierarchies: createEntityState<Schemas['SurgeryTypeGroupHierarchyOut']>(),
    surgeryTypeGroups: createEntityState<Schemas['SurgeryTypeGroupOut']>(),
    surgeryTypeGroupSpecialities: createEntityState<Schemas['SurgeryTypeGroupSpecialityOut']>(),
    tacticalPlanSnapshots: createEntityState<Schemas['TacticalPlanSnapshotOut']>(),
} satisfies Record<DiEntityKey, EntityTable<SomeEntity>>

export const entityApiGuards = {
    ageGroups: api.isAgeGroupOut,
    backfillQueues: api.isBackfillQueueOut,
    blockSchedules: api.isBlockScheduleOut,
    checklistItemDefinitions: api.isChecklistItemDefinitionOut,
    comments: api.isCommentOut,
    commentsMessageReactions: api.isCommentsMessageReactionOut,
    commentsMessages: api.isCommentsMessageOut,
    commentsThreadReactions: api.isCommentsThreadReactionOut,
    commentsThreads: api.isCommentsThreadOut,
    departmentLocationAssignments: api.isDepartmentLocationAssignmentOut,
    departmentPractitionerAssignments: api.isDepartmentPractitionerAssignmentOut,
    departments: api.isDepartmentOut,
    hospitalSurgeryTypeGroupAssociations: api.isHospitalSurgeryTypeGroupAssociationOut,
    hospitalSurgeryTypes: api.isHospitalSurgeryTypeOut,
    inboxEntries: api.isInboxEntryOut,
    locationPostOpAssociations: api.isLocationPostOpAssociationOut,
    locationProfiles: api.isLocationProfileOut,
    locationProfileSurgeryTypeGroups: api.isLocationProfileSurgeryTypeGroupOut,
    locations: api.isLocationOut,
    locationScheduleActivityLogs: api.isLocationScheduleActivityLogOut,
    locationSchedules: api.isLocationScheduleOut,
    locationScheduleSpecialities: api.isLocationScheduleSpecialityOut,
    locationScheduleSpecialityActivityLogs: api.isLocationScheduleSpecialityActivityLogOut,
    locationServiceOverrides: api.isLocationServiceOverrideOut,
    mailingList: api.isMailingListOut,
    planningDomains: api.isPlanningDomainOut,
    planningNoteHistoryRecords: api.isPlanningNoteHistoryRecordOut,
    planningNoteMigrations: api.isPlanningNoteMigrationRecordOut,
    planningPeriods: api.isPlanningPeriodOut,
    postOpCapacityOverrides: api.isPostOpCapacityOverrideOut,
    postOpCapacityPeriods: api.isPostOpCapacityPeriodOut,
    postOps: api.isPostOpOut,
    practitionerProfiles: api.isPractitionerProfileOut,
    practitionerProfileSurgeryTypeGroups: api.isPractitionerProfileSurgeryTypeGroupOut,
    practitioners: api.isPractitionerOut,
    practitionerScheduleActivityLogs: api.isPractitionerScheduleActivityLogOut,
    practitionerScheduleLocationActivityLogs: api.isPractitionerScheduleLocationActivityLogOut,
    practitionerScheduleLocations: api.isPractitionerScheduleLocationOut,
    practitionerSchedules: api.isPractitionerScheduleOut,
    practitionerScheduleStatusActivityLogs: api.isPractitionerScheduleStatusActivityLogOut,
    practitionerScheduleStatuses: api.isPractitionerScheduleStatusOut,
    practitionerServicePeriods: api.isPractitionerServicePeriodOut,
    practitionerStatusDefinitions: api.isPractitionerStatusDefinitionOut,
    prioritizedPatientGroups: api.isPrioritizedPatientGroupOut,
    recurringAssignments: api.isRecurringAssignmentOut,
    sections: api.isSectionOut,
    specialities: api.isSpecialityOut,
    staffingPlanExecutions: api.isStaffingPlanExecutionOut,
    staffingSurgeryGroups: api.isStaffingSurgeryGroupOut,
    staffingSurgeryGroupSurgeryTypeGroups: api.isStaffingSurgeryGroupSurgeryTypeGroupOut,
    statusDefinitionDepartmentAssignments: api.isStatusDefinitionDepartmentAssignmentOut,
    surgeryFolderMetadata: api.isSurgeryFolderMetadatumOut,
    surgeryMetadataSuggestions: api.isSurgeryMetadataSuggestionOut,
    surgeryTypeGroupAgeRestrictions: api.isSurgeryTypeGroupAgeRestrictionOut,
    surgeryTypeGroupHierarchies: api.isSurgeryTypeGroupHierarchyOut,
    surgeryTypeGroups: api.isSurgeryTypeGroupOut,
    surgeryTypeGroupSpecialities: api.isSurgeryTypeGroupSpecialityOut,
    tacticalPlanSnapshots: api.isTacticalPlanSnapshotOut,
} satisfies Record<DiEntityKey, (entity: SomeEntity) => boolean>

// O(1) lookup map from entity_type to store key
export const entityTypeToKey: Record<string, DiEntityKey> = {
    age_group: 'ageGroups',
    backfill_queue: 'backfillQueues',
    block_schedule: 'blockSchedules',
    checklist_item_definition: 'checklistItemDefinitions',
    comment: 'comments',
    comments_message_reaction: 'commentsMessageReactions',
    comments_message: 'commentsMessages',
    comments_thread_reaction: 'commentsThreadReactions',
    comments_thread: 'commentsThreads',
    department_location_assignment: 'departmentLocationAssignments',
    department_practitioner_assignment: 'departmentPractitionerAssignments',
    department: 'departments',
    hospital_surgery_type_group_association: 'hospitalSurgeryTypeGroupAssociations',
    hospital_surgery_type: 'hospitalSurgeryTypes',
    inbox_entry: 'inboxEntries',
    location_post_op_association: 'locationPostOpAssociations',
    location_profile: 'locationProfiles',
    location_profile_surgery_type_group: 'locationProfileSurgeryTypeGroups',
    location: 'locations',
    location_schedule_activity_log: 'locationScheduleActivityLogs',
    location_schedule: 'locationSchedules',
    location_schedule_speciality: 'locationScheduleSpecialities',
    location_schedule_speciality_activity_log: 'locationScheduleSpecialityActivityLogs',
    location_service_override: 'locationServiceOverrides',
    email: 'mailingList',
    planning_domain: 'planningDomains',
    planning_note_history_record: 'planningNoteHistoryRecords',
    planning_note_migration_record: 'planningNoteMigrations',
    planning_period: 'planningPeriods',
    post_op_capacity_override: 'postOpCapacityOverrides',
    post_op_capacity_period: 'postOpCapacityPeriods',
    post_op: 'postOps',
    practitioner_profile: 'practitionerProfiles',
    practitioner_profile_surgery_type_group: 'practitionerProfileSurgeryTypeGroups',
    practitioner: 'practitioners',
    practitioner_schedule_activity_log: 'practitionerScheduleActivityLogs',
    practitioner_schedule_location_activity_log: 'practitionerScheduleLocationActivityLogs',
    practitioner_schedule_location: 'practitionerScheduleLocations',
    practitioner_schedule: 'practitionerSchedules',
    practitioner_schedule_status_activity_log: 'practitionerScheduleStatusActivityLogs',
    practitioner_schedule_status: 'practitionerScheduleStatuses',
    practitioner_service_period: 'practitionerServicePeriods',
    practitioner_status_definition: 'practitionerStatusDefinitions',
    prioritized_patient_group: 'prioritizedPatientGroups',
    recurring_assignment: 'recurringAssignments',
    section: 'sections',
    speciality: 'specialities',
    staffing_plan_execution: 'staffingPlanExecutions',
    staffing_surgery_group: 'staffingSurgeryGroups',
    staffing_surgery_group_surgery_type_group: 'staffingSurgeryGroupSurgeryTypeGroups',
    status_definition_department_assignment: 'statusDefinitionDepartmentAssignments',
    surgery_folder_metadatum: 'surgeryFolderMetadata',
    surgery_metadata_suggestion: 'surgeryMetadataSuggestions',
    surgery_type_group_age_restriction: 'surgeryTypeGroupAgeRestrictions',
    surgery_type_group_hierarchy: 'surgeryTypeGroupHierarchies',
    surgery_type_group: 'surgeryTypeGroups',
    surgery_type_group_speciality: 'surgeryTypeGroupSpecialities',
    tactical_plan_snapshot: 'tacticalPlanSnapshots',
}
